import { unlimited, advanced, advancedOnSale } from '../../plans'

function hasPremiumPlan(plan) {
    return plan === unlimited.plan || plan === advanced.plan || plan === advancedOnSale.plan
}

module.exports = {
    hasPremiumPlan
}